import { NetworksState } from './types'

export const networksSelector = (state: any): NetworksState => {
  const { networks: {items, status, domains} } = state.networks;

  return { status, items: items, domains: domains };
}
